/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    baseStyle: {
        container: {
            minWidth: 'xs',
            width: 'full',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            paddingLeft: 4,
            display: {base: 'none', lg: 'flex'}
        },
        stackContainer: {
            whiteSpace: 'nowrap',
            flexWrap: 'wrap'
        },
        popoverContent: {
            marginLeft: 'auto',
            marginRight: 'auto',
            border: 0,
            minWidth: '100%',
            position: 'absolute',
            background: '#f8f6f3',
            padding: ['24px 0 32px'],
            minHeight: ['250px'],
            borderRadius: ['0 0 8px 8px'],
            maxHeight: ['500px'],
            overflow: ['auto'],
            boxShadow: '0 3px 5px rgba(43, 36, 25, .4)',
            _focusVisible: {
                boxShadow: 'none !important',
                outline: 'none'
            }
        },
        popoverBody: {
            padding: {base: '0 16px', md: '0 32px', lg: '0 64px'}
        },
        popoverContainer: {
            paddingTop: 0,
            paddingBottom: 8
        },
        listMenuTriggerContainer: {
            display: 'flex',
            alignItems: 'center'
        },
        listMenuTriggerLink: {
            display: 'block',
            whiteSpace: 'nowrap',
            position: 'relative',
            color: 'mainMenuColor',
            padding: ['0 12px'],
            fontSize: ['16px', '16px', '12px', '16px'],
            margin: ['12px 0'],
            _hover: {
                textDecoration: 'none'
            }
        },
        listMenuTriggerLinkActive: {
            textDecoration: 'none',
            color: 'orangeBaseColor',
            _before: {
                content: '""',
                position: 'absolute',
                bottom: '-17px',
                left: '0',
                display: 'block',
                border: 'none',
                right: '0',
                margin: '0 auto',
                width: '0',
                height: '0',
                borderLeft: '10px solid transparent',
                borderRight: '10px solid transparent',
                borderTop: '10px solid #000',
                zIndex: 9999
            }
        },
        listMenuTriggerlessLinkActive: {
            textDecoration: 'none',
            color: 'orangeBaseColor',
            _before: {
                position: 'absolute',
                backgroundColor: 'black',
                content: 'attr(name)',
                height: '2px',
                width: '-webkit-fill-available',
                color: 'transparent',
                bottom: '0px'
            }
        },
        listMenuTriggerLinkIcon: {
            marginTop: 3,
            marginRight: 3,
            marginBottom: 2,
            marginLeft: 0,
            _hover: {
                textDecoration: 'none'
            }
        }
    },
    parts: [
        'container',
        'stackContainer',
        'popoverContent',
        'popoverContainer',
        'listMenuTriggerContainer',
        'listMenuTriggerLink',
        'listMenuTriggerLinkActive',
        'listMenuTriggerIcon'
    ]
}
